// Shared chrome for the expanded report card's gray sections (metadata / tags / etc.),
// so ReportVersionPanel and ReportAITags stay visually in sync.
export var CARD_SECTION = "px-4 py-3 bg-gray-50 dark:bg-gray-800/60 border-t border-gray-200 dark:border-gray-700";
export var CARD_SECTION_LABEL = "text-[9px] font-semibold tracking-[0.07em] uppercase text-gray-400 dark:text-gray-500";